import { createAction, handleActions } from 'redux-actions'
import api from './api'

const SEED_DB = createAction('app/SEED_DB')
const SEED_DB_SUCCESS = createAction('app/SEED_DB_SUCCESS')
const SEED_DB_ERROR = createAction('app/SEED_DB_ERROR')

const initialState = {
  loading: false
}

export default handleActions(
  {
    [SEED_DB]: (state, action) => ({
      ...state,
      loading: true
    }),
    [SEED_DB_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [SEED_DB_ERROR]: (state, action) => ({
      ...state,
      loading: false
    })
  },
  initialState
)

export const seedDb = () => {
  return dispatch => {
    dispatch(SEED_DB())
    return api
      .post('app/dbseed', '', '')
      .then(res => {
        dispatch(SEED_DB_SUCCESS())
      })
      .catch(error => {
        dispatch(SEED_DB_ERROR())
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/app.js